import { render } from "./Religion.vue?vue&type=template&id=3536fa26"
import script from "./Religion.vue?vue&type=script&lang=js"
export * from "./Religion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__